import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Table } from "react-bootstrap";

const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const AeroTable28 = ({ data }) => {
  const pdfRef = useRef();

  if (!data.length) return <p>No Data Available</p>;

  // Generate table headers dynamically
  const tableHeaders = ["Race", "2018", "2019", "2020", "2021", "2022", "2023", "2024"];

  // Extract labels for the chart
  const chartLabels = data.map((item) => item.race_label);

  // Chart Data
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "2018",
        data: data.map((item) => parseInt(item["2018"])),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "2019",
        data: data.map((item) => parseInt(item["2019"])),
        backgroundColor: "rgba(54, 162, 235, 0.6)",
      },
      {
        label: "2020",
        data: data.map((item) => parseInt(item["2020"])),
        backgroundColor: "rgba(255, 206, 86, 0.6)",
      },
      {
        label: "2021",
        data: data.map((item) => parseInt(item["2021"])),
        backgroundColor: "rgba(75, 192, 192, 0.8)",
      },
      {
        label: "2022",
        data: data.map((item) => parseInt(item["2022"])),
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
      {
        label: "2023",
        data: data.map((item) => parseInt(item["2023"])),
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
      {
        label: "2024",
        data: data.map((item) => parseInt(item["2024"])),
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Employment by Race and Year",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Race",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Employment Count",
        },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;

    const originalWidth = input.style.width;
    input.style.width = "1100px";
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4"); // Portrait mode, A4 size

      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add the header logo
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16); // (x, y, width, height)

      // Add "UTahData.org" text beside the logo
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22); // Position the text next to the logo

      // Add clickable link
      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString(); // Format: MM/DD/YYYY or DD/MM/YYYY based on locale
      pdf.setFontSize(12);
      pdf.text(`Downloaded on: ${formattedDate}`, 150, 295);

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.line(10, 35, 200, 35);

      // Add the main content (adjust position to avoid overlap with header)
      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.line(10, 260, 200, 260);

      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);

      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);

      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);

      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("dashboard_with_footer.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <div className="dashboard-container">
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Employment by Race and Year (2018-2024)</h2>

          {/* Render Table with Horizontal Scrolling */}
          <div style={{ overflowX: "auto", marginBottom: "20px" }}>
            <Table bordered style={{ minWidth: "800px" }}>
              <thead>
                <tr>
                  {tableHeaders.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{row.race_label}</td>
                    <td>{row["2018"]}</td>
                    <td>{row["2019"]}</td>
                    <td>{row["2020"]}</td>
                    <td>{row["2021"]}</td>
                    <td>{row["2022"]}</td>
                    <td>{row["2023"]}</td>
                    <td>{row["2024"]}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Bar Chart Section */}
          <div
            style={{
              width: "90%",
              maxWidth: "800px",
              margin: "auto",
              overflowX: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                minWidth: "600px",
                height: "400px",
                background: "#fff",
              }}
            >
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>
      </div>

      {/* PDF Download Button */}
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default AeroTable28;
